import { render, staticRenderFns } from "./page-element-logo.vue?vue&type=template&id=30c1a0e0&scoped=true"
import script from "./page-element-logo.vue?vue&type=script&lang=js"
export * from "./page-element-logo.vue?vue&type=script&lang=js"
import style0 from "./page-element-logo.vue?vue&type=style&index=0&id=30c1a0e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c1a0e0",
  null
  
)

export default component.exports